<template>
  <div class="item-element">
    <div
      class="quote"
       v-html="description"
    />
  </div>
</template>

<script>
export default {
  name: 'sp-feature-quote-description',
  props: {
    description: {
      type: String,
      required: true,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./scss/variables.scss";

.quote {
  font-style: italic;
  line-height: 2;
  font-weight: var(--testimonial-font-weight);

  // @jayce
  // Disabled quote styling as unnecessary in
  // current implementation of layout.
  /*&:before,*/
  /*&:after {*/
  /*  font-size: 1.2em;*/
  /*  line-height: 1;*/
  /*}*/

  /*&:before { content: open-quote; }*/
  /*&:after { content: close-quote; }*/
}

.item-element:not(:last-child) { margin-bottom: var(--testimonial-element-margin); }
</style>
